
import Contact from './components/Contact'
import Footer from './components/Footer'
import Home from './components/Home'
import FlowSection from './components/FlowSection'
import ScrollToTop from './components/ScrollToTop'
import Banner from './components/Banner'
import Navbar from './components/Navbar'
import Section from './components/section'
import Case from './components/Case'
import ServiceCard from './components/ServiceCard'
import Table from './components/Table'
import Banner2 from './components/Banner2'
import Banner3 from './components/Banner3'


import {motion} from 'framer-motion'

import React from 'react'

function App() {
  return (
    <motion.div initial="hidden" animate="show">
      <Navbar/>
      <Home/>
      <Section/>
      <Banner/>
      <Case/>
      <Banner2/>
      <ServiceCard/>
      <FlowSection/>
      <Table/>
      <Banner3/>
      <Contact/>
      <Footer/>
      <ScrollToTop/>
    </motion.div>
  )
}

export default App
